import { render, staticRenderFns } from "./ButtonBienVendu.vue?vue&type=template&id=d22769ba&"
import script from "./ButtonBienVendu.vue?vue&type=script&lang=js&"
export * from "./ButtonBienVendu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports